<div class="flex flex-col pin-container">
  <ng-template #menuItems>
    <pin-menu-items [isSsoUser]="isSsoUser" [hasCustomerLevelAccess]="hasCustomerLevelAccess" [closeMenu]="closeMenu"></pin-menu-items>
  </ng-template>

  <pin-menu [userName]="userName" [menuItemsTemplate]="menuItems" [closeMenu]="closeMenu" class="md:hidden"></pin-menu>

  <!-- Header container -->
  <div class="header--main">
    <div class="header-container">
      <pin-header type="authenticated" [customClass]="customClass"
                  (userNameEvent)="setUserName($event)"
                  (isSsoUserEvent)="setIsSsoUser($event)"
                  (hasCustomerLevelAccessEvent)="setHasCustomerLevelAccess($event)">
      </pin-header>
    </div>
  </div>

  <div class="container--main authenticated pb-16">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Footer container -->
  <div class="footer--main">
    <pin-footer type="authenticated" customClass="bg-white"></pin-footer>
  </div>
</div>
